import React, { FC, memo, useCallback, useContext, useEffect, useMemo, useState } from 'react'

import ListingSectionTransport from '../../../transports/common/listing-section-transport'
import { useTranslation } from '../../../hooks/locale'
import { ScreenContext } from 'react-components'
import { Slide } from 'pure-react-carousel'

import {
    Container,
    PopularFilterListingsWrapper,
    SliderContainer,
    StyledCarouselProvider,
    StyledSlider,
} from './styles'
import { CtaButtonText, CtaContainer, StyledGhostButton, Subtitle, Title, TitleContainer } from '../common/styles'
import GridCard from '../common/grid-card'
import { BreadcrumbListTransport } from '../../../models/common/breadcrumb-model'
import { useResponsiveMobileSlides } from '../hooks'

interface Props {
    popularFilterListingsSection: ListingSectionTransport
    url: string
    sectionId: string
    breadcrumbList?: BreadcrumbListTransport
}

const PopularFilterListingsSection: FC<Props> = ({ popularFilterListingsSection, url, sectionId, breadcrumbList }) => {
    const { t } = useTranslation()
    const { isTablet, isDesktop } = useContext(ScreenContext)

    const _handleViewAllAccommodationsClick = useCallback(() => {
        document.location.href = popularFilterListingsSection?.cta?.url || url
    }, [url])

    const popularFilterListingObjects = popularFilterListingsSection?.objects
    const mobileVisibleSlides = useResponsiveMobileSlides({ smallMobile: 1.5, defaultMobile: 1.75 })

    if (popularFilterListingsSection?.objects?.length <= 0) {
        return null
    }

    return (
        <Container id={sectionId}>
            <TitleContainer>
                <Title>{popularFilterListingsSection.heading}</Title>
                <Subtitle>{popularFilterListingsSection.subheading}</Subtitle>
            </TitleContainer>

            {isDesktop ? (
                <PopularFilterListingsWrapper>
                    {popularFilterListingObjects.map((object, index) => (
                        <GridCard
                            key={object.id}
                            listingObject={object}
                            position={index}
                            breadcrumbList={breadcrumbList}
                        />
                    ))}
                </PopularFilterListingsWrapper>
            ) : (
                <SliderContainer>
                    <StyledCarouselProvider
                        totalSlides={popularFilterListingObjects.length}
                        visibleSlides={isTablet ? 2.4 : mobileVisibleSlides}
                        naturalSlideWidth={1}
                        naturalSlideHeight={1}
                        isIntrinsicHeight
                        lockOnWindowScroll
                        dragStep={1}
                        center
                    >
                        <StyledSlider $transitionTime={0.2}>
                            {popularFilterListingObjects.map((object, index) => (
                                <Slide index={object.id} key={`${index}_${object.id}`}>
                                    <GridCard listingObject={object} position={index} />
                                </Slide>
                            ))}
                        </StyledSlider>
                    </StyledCarouselProvider>
                </SliderContainer>
            )}

            {popularFilterListingsSection.cta?.url && (
                <CtaContainer>
                    <StyledGhostButton onClick={_handleViewAllAccommodationsClick} borderRadius="16px">
                        <CtaButtonText>{t('seeAll')}</CtaButtonText>
                    </StyledGhostButton>
                </CtaContainer>
            )}
        </Container>
    )
}

export default memo(PopularFilterListingsSection)
